export const ActionTypes = {
   getChangedProducts: 'moderation/changedProducts',
   getChangedProduct: 'moderation/changedProduct',
   approveChanges: `moderation/approveChanges`,
   declineChanges: `moderation/declineChanges`,
   patchChanges: `moderation/patchChanges`,
   approveChangesBulk: `moderation/approveChangesBulk`
}
